import PropTypes from 'prop-types'
import React from 'react'

const ChannelToken = ({ channel }) => (
  <div className="token">
    <strong>{ channel.title }</strong><br />
    <span>{ channel.description }</span>
  </div>
)

ChannelToken.propTypes = {
  channel: PropTypes.object
}

export default ChannelToken
